import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';        
import { CheckmarkCircle } from './checkmarkCircle';

export interface ILinearProgressBarProps extends LinearProgressProps{
  value?:      number,
  label?:      string,
  completed?:  boolean,
  notStarted?: boolean,
}

export const LinearProgressBar = (props: ILinearProgressBarProps) => {
  const { notStarted, label, completed } = props;
  const { t } = useTranslation();

  const _label = completed 
    ? t('progress_completed') 
    : notStarted 
      ? t('progress_unstarted')
      : label;

  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box sx={{ width: '100%', mr: 1 }}>
        <Box display='flex' alignItems='center' gap={1} color={completed ? '#00AB84' : "text.secondary"} marginBottom={"4px"}>
          {completed && 
            <CheckmarkCircle />
          }
          {_label &&
            <Typography variant="body2">{_label}</Typography>
          }
        </Box>
        <LinearProgress 
          variant = "determinate"
          style   = {{borderRadius: "4px"}}
          {...props} 
        />
      </Box>
    </Box>
  );
}